import { useState, useEffect, useCallback } from 'react';
import { getApiBaseUrl } from '../utils/api';

const API_BASE_URL = getApiBaseUrl();

const useCoursesData = (user) => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [coursesPagination, setCoursesPagination] = useState({
    current_page: 1,
    per_page: 25,
    total: 0,
    total_pages: 0,
    has_next: false,
    has_prev: false,
  });

  // Search states
  const [courseSearchTerm, setCourseSearchTerm] = useState("");
  const [courseSearchQuery, setCourseSearchQuery] = useState("");

  // Fetch courses function
  const fetchCourses = useCallback(
    async (page = 1, search = "") => {
      if (!user?.id) {
        console.error("User ID not available");
        return;
      }

      try {
        setLoading(true);
        const params = new URLSearchParams({
          user_id: user.id,
          page: page,
          per_page: 25
        });

        if (search) {
          params.append("search", search);
        }

        const response = await fetch(`${API_BASE_URL}/admin/courses?${params}`);
        const data = await response.json();
        setCourses(data.courses || []);
        if (data.pagination) {
          setCoursesPagination(data.pagination);
        }
      } catch (error) {
        console.error("Error fetching courses:", error);
        setError("Erro ao carregar cursos");
      } finally {
        setLoading(false);
      }
    },
    [user?.id, API_BASE_URL]
  );

  useEffect(() => {
    if (user?.id) {
      fetchCourses();
    }
  }, [user?.id, fetchCourses]);

  return {
    // Data
    courses,

    // States
    loading,
    error,
    setError,

    // Pagination
    coursesPagination,

    // Search
    courseSearchTerm,
    setCourseSearchTerm,
    courseSearchQuery,
    setCourseSearchQuery,

    // Functions
    fetchCourses,
  };
};

export default useCoursesData;
